// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"116":"graphs","341":"modals","821":"eventlog","942":"admin-tools"}[chunkId] + "." + {"116":"7072c26d","341":"62e62710","821":"bdc199d4","942":"ddfc39af"}[chunkId] + ".js";
};